// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae3ff92c","821":"8fc34447"}[chunkId] + ".chunk.js";
};